/**
 * Date Only model.
 */
export class DateOnly extends Date {

	utc = true;

	constructor(date: Date | number = new Date(), utc: boolean = true) {
		super(date);
		this.utc = utc;
	}

	// Override toJSON method to customize serialization
	override toJSON(): string {
		let date: Date;
		if (this.utc) {
			date = new Date(this);
		} else {
			const offset = this.getTimezoneOffset();
			date = new Date(this.getTime() - (offset * 60 * 1000));
		}
		return date.toISOString().substring(0, 10); // Serialize to ISO string
	}

}